import script from "./ConsumoMateriaPrima.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumoMateriaPrima.vue?vue&type=script&setup=true&lang=js"

import "./ConsumoMateriaPrima.vue?vue&type=style&index=0&id=56ddb061&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ddb061"]])

export default __exports__